import React, { FC, PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';

import { camelToNormalize } from '@/helpers/common';

import { ScErrorGroup } from './styled';

export const ErrorGroup: FC<PropsWithChildren> = ({ children }) => {
  const { errorIcon: ErrorIcon } = useTheme();

  return (
    <ScErrorGroup>
      <ErrorIcon />
      <span>{children}</span>
    </ScErrorGroup>
  );
};

export type ErrorServe = {
  field: string;
  message: string | string[];
};

export const ErrorGroupList: FC<{ errors: ErrorServe[] }> = ({ errors }) => {
  return errors.length ? (
    <ErrorGroup>
      <ul>
        {errors.map(({ field, message }, index) => (
          <li key={index}>
            <span>{camelToNormalize(field)}</span>:{' '}
            {typeof message === 'string' && message}
            {Array.isArray(message) && message.join(', ')}
          </li>
        ))}
      </ul>
    </ErrorGroup>
  ) : null;
};
